// src/utils/toast.js
export default function showToast(text, type='error', duration=3000) {
    // 清除旧提示
    const oldDom = document.querySelector('.global-toast')
    if(oldDom) oldDom.remove()

    const div = document.createElement('div')
    div.className = 'global-toast glass'
    div.innerText = text

    Object.assign(div.style,{
        position:'fixed',
        top:'10%',
        left:'50%',
        transform:'translateX(-50%)',
        minWidth:'240px',
        padding:'10px 18px',
        borderRadius:'999px',
        zIndex:'999999',
        fontSize:'14px',
        boxShadow:'0 4px 20px rgba(0,0,0,0.15)',
        boxSizing:'border-box',
        transition:'all 0.22s ease',
        textAlign:'center',
        whiteSpace:'nowrap'
    })

    if(type === 'error'){
        div.style.backgroundColor='#fef2f2'
        div.style.color='#dc2626'
        div.style.border='1px solid #fecaca'
    }else{
        div.style.backgroundColor='#f0fdf4'
        div.style.color='#039855'
        div.style.border='1px solid #bbf7d0'
    }

    document.body.appendChild(div)

    setTimeout(()=>{
        div.style.opacity='0'
        setTimeout(()=>div.remove(),220)
    },duration)
}
